import { Flex, Image, Modal } from "antd";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import { NO_IMAGE } from "@/constants/Global";

import { usePreviewModal } from "./preview-modal.hook";
import { previewModalAtom } from "./preview-modal.state";

const PreviewModal = () => {
  const { t } = useTranslation();
  const { visible, title, imageSrc } = useAtomValue(previewModalAtom);
  const { closePreviewModal } = usePreviewModal();

  const onClose = () => {
    closePreviewModal();
  };

  return (
    <Modal
      open={visible}
      title={title ?? t("global:preview")}
      onCancel={onClose}
      footer={null}
    >
      <Flex justify="center">
        <Image
          alt={t("global:preview")}
          style={{ width: "100%" }}
          src={imageSrc}
          fallback={NO_IMAGE}
          preview={false}
        />
      </Flex>
    </Modal>
  );
};

export default PreviewModal;
